import { fillArray } from 'src/helpers/fillArray'

import { SkeletonLoadingHistoryProps } from 'src/features/SkeletonLoadingHistory/types'
import { getArrayOfSkeletons } from 'src/features/SkeletonLoadingHistory/helper'
import { Skeleton } from 'src/components/shadcn/skeleton'
import { Card, CardContent } from 'src/components/shadcn/card'

export const SkeletonLoadingHistory = ({
  isList,
  countOfFields,
}: SkeletonLoadingHistoryProps): JSX.Element => {
  const list = getArrayOfSkeletons(isList)
  const fields = fillArray(countOfFields)

  return (
    <div className={isList ? '' : 'grid md:grid-cols-2 lg:grid-cols-3 gap-4'}>
      {list.map(item => (
        <div key={item} className={isList ? 'mt-3' : ''}>
          <Card className="group w-full p-6 border rounded-[10px]">
            <CardContent className="flex flex-col space-y-3 relative mt-3">
              <div className="flex items-center space-x-2 mb-2">
                <Skeleton className="h-6 w-[250px]" />
              </div>
              <div className="pt-2 space-y-3">
                {fields.map(field => (
                  <div key={field} className="flex justify-between text-sm">
                    <div className="flex items-center space-x-1">
                      <Skeleton className="h-2 w-[250px]" />
                    </div>
                    <Skeleton className="h-2 w-[100px]" />
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      ))}
    </div>
  )
}
